import React, { useEffect } from 'react';
import { compose } from 'lodash/fp';
import {
  connectStateResults,
  connectInfiniteHits,
} from 'react-instantsearch/connectors';
import ShowMoreButton from 'components/Learn/Search/Results/ShowMoreButton';
import AdvancedSearchResultCard from './AdvancedSearchResultCard';

function AdvancedSearchTitleResults({
  hits,
  searchResults,
  nbHitsChange,
  isActive,
  editableLessons,
}) {
  useEffect(() => {
    if (searchResults?.nbHits !== undefined) {
      nbHitsChange(searchResults?.nbHits);
    }
  }, [nbHitsChange, searchResults]);

  if (!isActive) {
    return null;
  }

  return (
    <>
      <div className="AdvancedSearchResults fw-w">
        {searchResults &&
          searchResults.nbHits > 0 &&
          hits.map(content => {
            return (
              <AdvancedSearchResultCard
                key={content.objectID}
                content={content}
                editable={
                  content.content_type === 'lesson'
                    ? !!editableLessons[content.l_id]
                    : true
                }
              />
            );
          })}
      </div>
      <ShowMoreButton featherIcon />
    </>
  );
}

export default compose(
  connectInfiniteHits,
  connectStateResults,
)(AdvancedSearchTitleResults);
